import { slicedToArray as _slicedToArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { forwardRef } from 'react';
import { i18n } from '../../../i18n/translate.js';
import { onExecuteKeyDown } from '../../../utils/KeyboardUtil.js';
import { RadioGroup } from '@chakra-ui/react';
import { Modal } from '../../../core/components/Modal/component.js';
import Button from '../../../core/components/Button/component.js';
import { Layout } from '../../../core/components/Layout/component.js';
import { Radio } from '../../../core/components/Radio/component.js';
var LanguageModalBody = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var buttonDisabled = _ref.buttonDisabled,
    confirmSelection = _ref.confirmSelection,
    enforceSelection = _ref.enforceSelection,
    languages = _ref.languages,
    onClose = _ref.onClose,
    renderedTitle = _ref.renderedTitle,
    selected = _ref.selected,
    setSelected = _ref.setSelected,
    showLanguageModal = _ref.showLanguageModal;
  return /*#__PURE__*/React.createElement(Modal
  // @ts-ignore
  , {
    ref: ref,
    size: "sm",
    id: "languages-modal",
    isOpen: showLanguageModal,
    modalType: 'modal',
    onClose: onClose,
    showCloseButton: !enforceSelection,
    variant: 'default',
    header: renderedTitle,
    footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      onClick: onClose,
      variant: 'secondary'
    }, i18n.t('Cancel')), /*#__PURE__*/React.createElement(Button, {
      isDisabled: buttonDisabled,
      onClick: confirmSelection,
      variant: "primary",
      "data-action": "save-language"
    }, i18n.t('Save')))
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    "data-object-type": "language-modal-body",
    onChange: setSelected,
    value: selected
  }, /*#__PURE__*/React.createElement(Layout, {
    variant: "stack",
    direction: "column"
  }, Object.entries(languages).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      code = _ref3[0],
      native_name = _ref3[1].native_name;
    var isSelected = selected === code;
    return /*#__PURE__*/React.createElement(Radio, {
      label: native_name,
      key: code,
      value: code,
      tabIndex: -1,
      "aria-pressed": isSelected,
      onKeyDown: onExecuteKeyDown(function () {
        return setSelected(code);
      }),
      "data-object-type": "languages",
      "data-object-id": code,
      "data-selected": isSelected
    });
  }))));
});
LanguageModalBody.displayName = 'LanguageModalBody';
export { LanguageModalBody };